export var sizes = {
  /** 32px */
  xl5: '32px',
  /** 29px */
  xl4: '29px',
  /** 26px */
  xl3: '26px',
  /** 23px */
  xl2: '23px',
  /** 20px */
  xl: '20px',
  /** 18px */
  lg: '18px',
  /** 16px */
  base: '16px',
  /** 14px */
  sml: '14px',
  /** 12px */
  xsml: '12px',
  /** 11px */
  xsml2: '11px'
};
export var weights = {
  /** 300 */
  light: 300,
  /** 400 */
  regular: 400,
  /** 500 */
  medium: 500,
  /** 600 */
  semiBold: 600
};